// 공지사항(시안 v6 §8) 화면용 순수 함수. 게시 상태는 서버가 준다(scheduled·active·expired).
import { kstFull } from "../../inquiry/view";

export const EMPTY_FORM = { title: "", content: "", imp: false, push: false, start: "", end: "", titleZh: "", contentZh: "" };

export const STATUS_TABS = [
    { code: "all", label: "전체", key: "total" },
    { code: "active", label: "게시중", key: "active" },
    { code: "scheduled", label: "예약", key: "scheduled" },
    { code: "expired", label: "만료", key: "expired" },
];

// 서버 시각(ISO) → <input type="datetime-local"> 값(서울 벽시계)
export const toLocalInput = (iso) => (iso ? kstFull(iso).replace(" ", "T") : "");
// datetime-local 값 → 서울 오프셋을 붙인 ISO. 비면 null(즉시 게시 · 무기한)
export const toServerTime = (v) => (v ? `${v}:00+09:00` : null);

export const plain = (src) => String(src || "")
    .replace(/!\[.*?\]\(.*?\)/g, "[이미지]").replace(/^#+ /gm, "").replace(/\*\*/g, "")
    .replace(/^\s*[-*] /gm, "· ").replace(/\n+/g, " ").trim();

export function validate(f) {
    const miss = [];
    if (!f.title.trim()) miss.push("제목");
    if (!f.content.trim()) miss.push("내용");
    if (miss.length) return `${miss.join(", ")}을(를) 입력해 주세요.`;
    if (f.start && f.end && f.end < f.start) return "게시 종료일이 시작일보다 앞설 수 없습니다.";
    return "";
}

const orNull = (s) => (s && s.trim() ? s.trim() : null);

// 작성자는 서버가 X-Admin-Id 로 넣는다 — author_admin_id 는 보내지 않는다
export const buildPayload = (f) => ({
    title: f.title.trim(), content: f.content.trim(),
    is_important: !!f.imp, push_requested: !!f.push,
    start_at: toServerTime(f.start), end_at: toServerTime(f.end),
    title_zh: orNull(f.titleZh), content_zh: orNull(f.contentZh),
});

export const formFrom = (n) => ({
    title: n.title || "", content: n.content || "", imp: !!n.is_important, push: !!n.push_requested,
    start: toLocalInput(n.start_at), end: toLocalInput(n.end_at),
    titleZh: n.title_zh || "", contentZh: n.content_zh || "",
});

const ORDER = { active: 0, scheduled: 1, expired: 2 };
export const sortNotices = (rows) => rows.slice().sort((a, b) =>
    (ORDER[a.status] ?? 3) - (ORDER[b.status] ?? 3) || String(b.created_at).localeCompare(String(a.created_at)));

// 이미지 마크다운을 커서 자리에 줄 단위로 넣는다(시안 ntImg)
export function insertAt(value, pos, urls) {
    const p = Math.min(pos ?? value.length, value.length);
    const head = value.slice(0, p) + (p && value[p - 1] !== "\n" ? "\n" : "");
    const ins = urls.map((u) => `![](${u})`).join("\n") + "\n";
    return { value: head + ins + value.slice(p), caret: head.length + ins.length };
}
